import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Select2Module } from 'ng2-select2';
import { SharedModule } from '../../shared/shared.module';
import { LaboratoryTestsListComponent } from './laboratory-tests-list/laboratory-tests-list.component';
import { LaboratoryTestsComponent } from './laboratory-tests.component';
import { LaboratoryTestsRoutingModule } from './laboratory-tests-routing.module';
import { ModalSendEmailComponent } from './modals/modal-send-email/modal-send-email.component';
import { ModalSecurityQuestionsComponent } from './modals/modal-security-questions/modal-security-questions.component';
import { InputEmailComponent } from './modals/modal-send-email/input-email/input-email.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    LaboratoryTestsRoutingModule,
    Select2Module
  ],
  declarations: [LaboratoryTestsComponent, LaboratoryTestsListComponent, ModalSendEmailComponent, ModalSecurityQuestionsComponent, InputEmailComponent],
  entryComponents: [InputEmailComponent]
})

export class LaboratoryTestsModule { }



// WEBPACK FOOTER //
// /app/src/app/office/laboratory-tests/laboratory-tests.module.ts